import { useContext } from 'react'
import bannerContext from './bannerContext'

const useBanner = () => {
  const { ...exposedFields } = useContext(bannerContext)

  return exposedFields
}

export default useBanner
